import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getLanguageLocalNameByLanguageCode } from '@mews-commander/core/legacy-globalization';
import { ApplicationState } from '@mews-commander/types';
import { FormLabel } from '@optimus-web/core';

interface OwnProps {
    languageCode: string;
}

interface StateProps {
    localLanguageName: string;
}

const LanguageLabel = ({ localLanguageName }: StateProps) => <FormLabel>{localLanguageName}</FormLabel>;

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        localLanguageName: getLanguageLocalNameByLanguageCode,
    })
)(LanguageLabel);
